export default "__VITE_ASSET__DcoKpUmn__"